// extracted by mini-css-extract-plugin
export default {"bottomElement":"HkKmpJLBQUTzay0tmU5apQ==","stickyContainer":"aaBuwLQgeRGfECU-hUQ6xQ=="};